import { SYSBaseElement, html } from "../../../../../../_ovlclient/src"
import {
  DialogHolderParams,
  DialogClose,
} from "../../../../../../_ovlclient/src/library/dialog/dialogapi"

export class CompImagePopup extends SYSBaseElement {
  async init() {
    this.dialog = "GENImagePopup"
    await super.init()
  }

  getBody = () => {
    return html`<img src="${this.state.app.features.GENImagePopup.imagePopup}"></img> `
  }

  async getUI() {
    let dialogHolderParams: DialogHolderParams
    dialogHolderParams = {
      dialogParts: {
        body: () => this.getBody(),
        dismissedCallbackFn: () => {
          DialogClose("GENImagePopup")
        },
        emptySpaceClickHandlerFn: () => {
          DialogClose("GENImagePopup")
        },
      },

      dialogType: "GENImagePopup",
    }
    return html`<ovl-dialogholder
      .dialogHolderParams=${dialogHolderParams}
    ></ovl-dialogholder>`
  }
}
